import React, { useState, useRef, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { Table, Input, Button, Tag, Space } from "antd";
import { TextField, Chip, Autocomplete, MenuItem, InputLabel, Popper, Dialog, DialogTitle, DialogContent, DialogActions, RadioGroup, FormControlLabel, Radio, IconButton, StepLabel, Stepper, Step } from "@mui/material";
import {
    PlusOutlined,
    DownloadOutlined,
    EditFilled,
    DeleteFilled,
    FileFilled,
    CheckCircleFilled
} from "@ant-design/icons";

import Select from "react-select";

import CloseIcon from "@mui/icons-material/Close";
const AppointmentList = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedPerson, setSelectedPerson] = useState("");
    const steps = [
        "Basic Info",
        "Emergency",
        "Health Overview",
        "Medications",
        "Family History",
        "Goals",
        "Final Input",
    ];
    const handleNext = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));

    const dataSource = [
        {
            key: "1",
            patientId: "PID-001",
            name: "Sarah Johnson",
            relation: "Spouse",
            dob: "05/20/1985",
            gender: "Male",
            bloodGroup: "A+",
            phone: "123-456-7890",
            status: "Confirmed",
        },
        {
            key: "2",
            patientId: "PID-002", // 👈 no patient ID
            name: "Emily Johnson",
            relation: "Daughter",
            dob: "02/11/2013",
            gender: "Female",
            bloodGroup: "O+",
            phone: "123-456-7890",
            status: "Completed",
        },
        {
            key: "2",
            patientId: "PID-002", // 👈 no patient ID
            name: "Emily Johnson",
            relation: "Daughter",
            dob: "02/11/2013",
            gender: "Female",
            bloodGroup: "O+",
            phone: "123-456-7890",
            status: "Confirmed",
        },
        {
            key: "2",
            patientId: "PID-002", // 👈 no patient ID
            name: "Emily Johnson",
            relation: "Daughter",
            dob: "02/11/2013",
            gender: "Female",
            bloodGroup: "O+",
            phone: "123-456-7890",
            status: "Upcoming",
        },
    ];


    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "na", label: "Prefer not to say" },
    ];

    const conditionsOptions = [
        { value: "hypertension", label: "Hypertension" },
        { value: "diabetes", label: "Diabetes" },
        { value: "heart", label: "Heart disease" },
        { value: "asthma", label: "Asthma" },
        { value: "none", label: "None" },
    ];
    const columns = [
        {
            title: "Doctor",
            dataIndex: "name",
            key: "name",
            render: (text: any, record: any) => (
                <div>
                    <div>{text}</div>
                    {/* {record.patientId == "PID-002" && (
            // <span className="blinker-badge" onClick={() => setShowModal1(true)}>
            //   Questionnare Pending
            // </span>
          )} */}
                </div>
            ),
        },
        {
            title: "Date & Time",
            dataIndex: "patientId",
            key: "patientId",
            render: (patientId: string | null) =>
                patientId ? (
                    patientId
                ) : (
                    <span className="pending-blink" onClick={() => setShowModal1(true)}>Pending</span>
                ),
        },


        {
            title: "Treatment",
            dataIndex: "relation",
            key: "relation",
        },
        {
            title: "Contact Number",
            dataIndex: "dob",
            key: "dob",
        },

        {
            title: "Location",
            dataIndex: "bloodGroup",
            key: "bloodGroup",
        },
        // {
        //   title: "Phone",
        //   dataIndex: "phone",
        //   key: "phone",
        // },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status: any) => {
                if (status === "Confirmed") {
                    return <Tag color="green">Confirmed</Tag>; // Green for Confirmed
                } else if (status === "Upcoming") {
                    return <Tag color="yellow">Upcoming</Tag>; // Yellow for Upcoming
                } else if (status === "Completed") {
                    return <Tag color="red">Completed</Tag>; // Green for Completed
                }
                return null; // Return null if no match
            },
        },

        {
            title: "Action",
            key: "action",
            render: () => (
                <Space>
                    {/* Replace Edit icon with Tick icon */}
                    <Button
                        shape="circle"
                        icon={<CheckCircleFilled />}
                        className="btn-edit"
                    />

                    {/* Remove this button if you want to remove the Document icon */}
                    <Button
                        shape="circle"
                        icon={<DeleteFilled />}
                        className="btn-delete"
                    />
                </Space>
            )
        }

    ];




    const yesNoOptions = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
    ];


    const supplementsOptions = [
        { value: "vitamins", label: "Vitamins" },
        { value: "herbal", label: "Herbal" },
        { value: "ayurvedic", label: "Ayurvedic" },
        { value: "homeopathic", label: "Homeopathic" },
        { value: "protein", label: "Protein supplements" },
        { value: "none", label: "None" },
    ];

    const familyOptions = [
        { value: "heart", label: "Heart disease" },
        { value: "stroke", label: "Stroke" },
        { value: "diabetes", label: "Diabetes" },
        { value: "cancer", label: "Cancer" },
        { value: "autoimmune", label: "Autoimmune" },
        { value: "mental", label: "Mental health" },
        { value: "dementia", label: "Dementia" },
        { value: "none", label: "None" },
        { value: "not_sure", label: "Not sure" },
    ];

    const goalsOptions = [
        { value: "medication", label: "Medication safety" },
        { value: "symptoms", label: "Symptoms" },
        { value: "chronic", label: "Chronic care" },
        { value: "prevention", label: "Prevention" },
        { value: "lifestyle", label: "Lifestyle" },
        { value: "lab", label: "Lab understanding" },
    ];

    const selectStyles = {
        control: (base: any) => ({
            ...base,
            minHeight: "38px",
            borderColor: "#ced4da",
            boxShadow: "none",
            "&:hover": { borderColor: "#86b7fe" },
        }),
    };


    const stepContents = [
        // Step 0 - Basic Info
        <div className="row g-3">
            <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control" placeholder="Enter full name" />
            </div>
            <div className="col-md-6">
                <label className="form-label">Date of Birth</label>
                <input type="date" className="form-control" />
            </div>
            <div className="col-md-6">
                <label className="form-label">Sex assigned at birth</label>
                <Select options={genderOptions} styles={{
                    ...selectStyles,
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 1500, // higher than MUI Dialog (default ~1300)
                    }),
                }} placeholder="Select" menuPortalTarget={document.body} />
            </div>
        </div>,

        // Step 1 - Emergency
        <div className="row g-3">
            <div className="col-md-6">
                <label className="form-label">Emergency Contact Name</label>
                <input type="text" className="form-control" placeholder="Name" />
            </div>
            <div className="col-md-6">
                <label className="form-label">Relationship</label>
                <input type="text" className="form-control" placeholder="Relationship" />
            </div>
            <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="tel" className="form-control" placeholder="Phone Number" />
            </div>
        </div>,

        // Step 2 - Health Overview
        <div className="col-12">
            <label className="form-label">Diagnosed Conditions</label>
            <Select options={conditionsOptions} isMulti styles={{
                ...selectStyles,
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500, // higher than MUI Dialog (default ~1300)
                }),
            }} placeholder="Select conditions" menuPortalTarget={document.body} />
        </div>,

        // Step 3 - Medications
        <div className="row g-3">
            <div className="col-md-6">
                <label className="form-label">Currently taking medications?</label>
                <Select options={supplementsOptions} styles={{
                    ...selectStyles,
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 1500, // higher than MUI Dialog (default ~1300)
                    }),
                }} menuPortalTarget={document.body} />
            </div>
            <div className="col-md-6">
                <label className="form-label">Medication Names</label>
                <input type="text" className="form-control" placeholder="Medication name(s)" />
            </div>
        </div>,

        // Step 4 - Family History
        <div className="col-12">
            <label className="form-label">Family Conditions</label>
            <Select options={familyOptions} isMulti styles={{
                ...selectStyles,
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500, // higher than MUI Dialog (default ~1300)
                }),
            }} placeholder="Select conditions" menuPortalTarget={document.body} />
        </div>,

        // Step 5 - Goals
        <div className="col-12">
            <label className="form-label">Goals</label>
            <Select options={goalsOptions} isMulti styles={{
                ...selectStyles,
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 1500, // higher than MUI Dialog (default ~1300)
                }),
            }} placeholder="Select goals" menuPortalTarget={document.body} />
        </div>,

        // Step 6 - Final Input
        <div className="col-12">
            <label className="form-label">Additional Information</label>
            <textarea className="form-control" rows={4} placeholder="Speak, Type, or Upload" />
        </div>,
    ];

    return (
        <div className="content-wrapper">
            <div className="container-full table-padding">

                <div className="page-header">


                    <div className="breadcrumb">
                        <h3 className="page-title">All Appointment</h3>
                        <span className="customize-breadcrumb">
                            <span className="home-icon">🏠</span>
                            <span className="separator"> - </span>
                            <span className="current">All Appointment</span>
                        </span>

                    </div>
                </div>
                <div className="family-card">

                    {/* Header */}
                    <div className="family-header">
                        {/* LEFT SIDE */}
                        <div className="left-side">
                            <p className="title">Appointment</p>
                            <Input placeholder="Search..." className="search-input" />
                        </div>

                        {/* RIGHT SIDE */}
                        <div className="right-side">
                            <Space>
                                <Button className="btn-add" icon={<PlusOutlined />} onClick={() => setShowModal(true)} />
                                <Button className="btn-download" icon={<DownloadOutlined />} />
                            </Space>
                        </div>
                    </div>


                    {/* Table */}
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        pagination={false}
                        className="family-table"
                    />

                    {/* Footer */}
                    <div className="family-footer">
                        Total 90 Patient
                    </div>

                </div>
            </div>








            <Dialog
                open={showModal}
                maxWidth="sm"
                fullWidth
                className="auth-modal glass-modal"
                onClose={() => setShowModal(false)}
                BackdropProps={{
                    style: {
                        backgroundColor: "rgba(0,0,0,0.2)",
                        backdropFilter: "blur(5px)",
                    },
                }}
            >
                {/* HEADER */}
                <DialogTitle className="pt-30 pb-10 text-center">
                    <h3 className="mb-1">Whom do you want to book an appointment </h3>
                    <p className="text-muted fs-14 mb-0">
                        Please select a family member
                    </p>
                </DialogTitle>

                {/* CONTENT */}
                <DialogContent className="px-40 pb-20 d-flex justify-content-center">
                    <RadioGroup
                        row
                        value={selectedPerson}
                        onChange={(e) => setSelectedPerson(e.target.value)}
                        className="justify-content-center mt-3"
                    >
                        <FormControlLabel value="father" control={<Radio />} label="Father" />
                        <FormControlLabel value="mother" control={<Radio />} label="Mother" />
                        <FormControlLabel value="sister" control={<Radio />} label="Sister" />
                        <FormControlLabel value="spouse" control={<Radio />} label="Spouse" />
                    </RadioGroup>

                </DialogContent>
                <p className="text-center text-muted  fs-12" style={{ padding: '0 7% 0 7%' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '14px', marginTop: '10px', display: 'block' }}>
                         Note
                    </span>
                    Scheduling this appointment, you acknowledge that the details provided are accurate to the best of your knowledge.
                </p>

                {/* FOOTER */}

                <DialogActions className="pb-3 px-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-warning"
                        onClick={() => {
                            // handle booking here
                            setShowModal(false)
                        }}>Cancel</button>
                    <button className="btn btn-primary" onClick={() => { setShowConfirm(false); navigate("/appointment") }} disabled={!selectedPerson}>Schedule Appointment</button>
                </DialogActions>

            </Dialog>






        </div>


    );
};

export default AppointmentList;
